import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getDiscounts() {
        return Axios.get(`${baseURL}reference/discounts`).then(
            response => response.data.response
        );
    },
    getPaymentTerms() {
        return Axios.get(`${baseURL}reference/payment-terms`).then(
            response => response.data.response
        );
    },
    getExemptionTypes() {
        return Axios.get(`${baseURL}reference/exemption-types`).then(
            response => response.data.response
        );
    },
    getCreditType(params) {
        return Axios.get(`${baseURL}reference/credit-type`, { params }).then(
            response => response.data.response
        );
    },
    getMasterDiagnostic() {
        return Axios.get(`${baseURL}reference/master-diagnostic`).then(
            response => response.data.response
        );
    },
    getMasterUOM(params) {
        return Axios.get(`${baseURL}reference/master-uom`, { params }).then(
            response => response.data.response.resources
        );
    },
    getDeclineTypes() {
        return Axios.get(`${baseURL}reference/decline-types`).then(
            response => response.data.response
        );
    }
};
